<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Nouvelle affaire</h2>
    <p class="page-subtitle">Renseignez les informations de l'affaire</p>
  </div>
  <button routerLink="/affaires" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </button>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="affaireForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations de l'affaire</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="numeroAffaire">NUMÉRO D'AFFAIRE</label>
            <input type="text" id="numeroAffaire" formControlName="numeroAffaire" class="form-control" placeholder="ex: AFF-2026-001">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Client associé</h3>
        <div class="form-row">
          <div class="form-group col">
            <label>CLIENT</label>
            <div class="dropdown-select" (click)="$event.stopPropagation()">
              <button type="button" class="select-btn" (click)="toggleClientDropdown()">
                {{ displaySelectedClient() }}
                <span class="caret">▾</span>
              </button>
              <div class="dropdown-panel" *ngIf="showClientDropdown()">
                <input type="text" class="dropdown-search" placeholder="Rechercher un client..." (input)="onClientSearchChange($any($event.target).value)">
                <div class="options-list">
                  @for (c of clientOptions(); track c.id) {
                    <div class="option-item" (click)="selectClient(c)">
                      <div class="option-title">{{ c.denomination }}</div>
                      <div class="option-sub">{{ c.numeroClient }} • {{ c.ville }}</div>
                    </div>
                  } @empty {
                    <div class="empty-option">Aucun client trouvé</div>
                  }
                </div>
                <button type="button" class="load-more" (click)="loadMoreClients()" [disabled]="clientPage() + 1 >= clientTotalPages() || isLoadingClients()">
                  {{ isLoadingClients() ? 'Chargement...' : (clientPage() + 1 < clientTotalPages() ? 'Charger plus' : 'Fin de liste') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }

      <div class="form-actions">
        <a routerLink="/affaires" class="btn btn-outline">Annuler</a>
        <button type="submit" [disabled]="affaireForm.invalid || isLoading()" class="btn btn-primary">
          {{ isLoading() ? 'Création...' : 'Créer l\'affaire' }}
        </button>
      </div>
    </form>
  </div>
</div>
